import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEye = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.9996 7C8.79129 7 6.63333 8.64109 5.37524 10.0429C4.3619 11.172 4.3619 12.828 5.37524 13.9571C6.63333 15.3589 8.79129 17 11.9996 17C15.2078 17 17.3658 15.3589 18.6239 13.9571C19.6372 12.828 19.6372 11.172 18.6239 10.0429C17.3658 8.64109 15.2078 7 11.9996 7Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 10,
		y: 10,
		width: 4,
		height: 4,
		rx: 2,
		stroke: "currentColor",
		strokeWidth: 2
	})]
});
export default SvgEye;
